(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


"use strict";
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        // eslint-disable-next-line no-console
        console.log(initialState);
        this.initialState = this.boardDeepCopy(initialState);
        this.board = this.boardDeepCopy(initialState);
        this.score = 0;
        this.status = "idle";
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this;
                this.performMove(function(board) {
                    return _this.joinTiles(board);
                });
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this;
                this.performMove(function(board) {
                    return _this.reverse(_this.joinTiles(_this.reverse(board)));
                });
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var _this = this;
                this.performMove(function(board) {
                    var transposed = _this.transpose(board);
                    var joined = _this.joinTiles(transposed);
                    return _this.transpose(joined);
                });
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var _this = this;
                this.performMove(function(board) {
                    var transposed = _this.transpose(board);
                    var reversed = _this.reverse(transposed);
                    var joined = _this.joinTiles(reversed);
                    var restored = _this.reverse(joined);
                    return _this.transpose(restored);
                });
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return this.boardDeepCopy(this.board);
            }
        },
        {
            /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            /**
   * Starts the game.
   */ key: "start",
            value: function start() {
                this.status = "playing";
                this.addRandomTile();
                this.addRandomTile();
            }
        },
        {
            /**
   * Resets the game.
   */ key: "restart",
            value: function restart() {
                this.status = "idle";
                this.board = this.boardDeepCopy(this.initialState);
                this.score = 0;
            }
        },
        {
            // Add your own methods here
            key: "addRandomTile",
            value: function addRandomTile() {
                var emptyCells = this.board.reduce(function(acc, row, rowIndex) {
                    row.forEach(function(cell, colIndex) {
                        if (cell === 0) acc.push({
                            row: rowIndex,
                            col: colIndex
                        });
                    });
                    return acc;
                }, []);
                if (emptyCells.length > 0) {
                    var _emptyCells_Math_floor = emptyCells[Math.floor(Math.random() * emptyCells.length)], row = _emptyCells_Math_floor.row, col = _emptyCells_Math_floor.col;
                    this.board[row][col] = Math.random() < 0.9 ? 2 : 4;
                }
                if (this.isGameOver()) this.status = "lose";
            }
        },
        {
            key: "joinTiles",
            value: function joinTiles(board) {
                var _this = this;
                return board.map(function(line) {
                    var filteredLine = line.filter(function(value) {
                        return value !== 0;
                    });
                    for(var i = 0; i < filteredLine.length; i++)if (filteredLine[i] === filteredLine[i + 1]) {
                        filteredLine[i] *= 2;
                        _this.score += filteredLine[i];
                        if (filteredLine[i] === 2048) _this.status = "win";
                        filteredLine.splice(i + 1, 1);
                    }
                    while(filteredLine.length < 4)filteredLine.push(0);
                    return filteredLine;
                });
            }
        },
        {
            key: "transpose",
            value: function transpose(board) {
                return board[0].map(function(_, colInd) {
                    return board.map(function(row) {
                        return row[colInd];
                    });
                });
            }
        },
        {
            key: "reverse",
            value: function reverse(board) {
                return board.map(function(line) {
                    return line.reverse();
                });
            }
        },
        {
            key: "boardDeepCopy",
            value: function boardDeepCopy(toCopy) {
                return JSON.parse(JSON.stringify(toCopy));
            }
        },
        {
            key: "isGameOver",
            value: function isGameOver() {
                for(var i = 0; i < 4; i++)for(var j = 0; j < 4; j++){
                    var current = this.board[i][j];
                    if (this.board[i][j] === 0 || i < 3 && current === this.board[i + 1][j] || j < 3 && current === this.board[i][j + 1]) return false;
                }
                return true;
            }
        },
        {
            key: "performMove",
            value: function performMove(moveFunction) {
                if (this.status !== "playing") return;
                var boardBeforeMove = JSON.stringify(this.board);
                this.board = moveFunction(this.board);
                if (JSON.stringify(this.board) !== boardBeforeMove) this.addRandomTile();
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
// Write your code here
var $197cd56b15c33885$var$gameButton = document.querySelector(".button");
var $197cd56b15c33885$var$gameScore = document.querySelector(".game-score");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$messageLose = document.querySelector(".message-lose");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$gameField = document.querySelector(".game-field");
document.addEventListener("keyup", function(arrow) {
    if ($197cd56b15c33885$var$game.status === "playing") {
        switch(arrow.key){
            case "ArrowUp":
                $197cd56b15c33885$var$game.moveUp();
                break;
            case "ArrowDown":
                $197cd56b15c33885$var$game.moveDown();
                break;
            case "ArrowRight":
                $197cd56b15c33885$var$game.moveRight();
                break;
            case "ArrowLeft":
                $197cd56b15c33885$var$game.moveLeft();
                break;
            default:
                break;
        }
        $197cd56b15c33885$var$updateUi($197cd56b15c33885$var$game.board);
        if ($197cd56b15c33885$var$game.getStatus() === "win") $197cd56b15c33885$var$messageWin.classList.remove("hidden");
        if ($197cd56b15c33885$var$game.getStatus() === "lose") $197cd56b15c33885$var$messageLose.classList.remove("hidden");
    }
});
function $197cd56b15c33885$var$updateUi(board) {
    var cells = $197cd56b15c33885$var$gameField.querySelectorAll(".field-cell");
    board.flat().forEach(function(value, index) {
        var cell = cells[index];
        cell.textContent = value === 0 ? "" : value;
        cell.className = "field-cell ".concat(value > 0 ? "field-cell--".concat(value) : "");
    });
    $197cd56b15c33885$var$gameScore.textContent = $197cd56b15c33885$var$game.getScore();
}
$197cd56b15c33885$var$gameButton.addEventListener("click", function(e) {
    var button = e.target;
    if (button.classList.contains("start")) {
        $197cd56b15c33885$var$game.start();
        button.classList.replace("start", "restart");
        button.textContent = "Restart";
        $197cd56b15c33885$var$messageStart.classList.add("hidden");
        $197cd56b15c33885$var$updateUi($197cd56b15c33885$var$game.board);
    } else {
        $197cd56b15c33885$var$game.restart();
        button.classList.replace("restart", "start");
        button.textContent = "Start";
        $197cd56b15c33885$var$messageStart.classList.remove("hidden");
        $197cd56b15c33885$var$messageWin.classList.add("hidden");
        $197cd56b15c33885$var$messageLose.classList.add("hidden");
        $197cd56b15c33885$var$updateUi($197cd56b15c33885$var$game.board);
    }
});

})();
//# sourceMappingURL=index.05d697f3.js.map
